import { Link } from "react-router-dom";
import { MdEvent, MdEventNote, MdLocationOn } from "react-icons/md";
import {
  FaMicrophone,
  FaHandshake,
  FaStore,
  FaUserPlus,
  FaCalendarAlt,
} from "react-icons/fa";
import { useEvent } from "../../../context/EventContext";

// The SideBar component renders the sidebar for the Organizer Dashboard page.
//  * It renders the following sections: Main Event, Location Details, List of Speakers,Registration Types, List of Sponser, List of Stalls, Agenda.
//  * Each section is a link to the corresponding page.
//  * The component also renders a progress bar showing the percentage of the main event form filled.
//  * The active section is highlighted in the sidebar.
const SideBar = ({ activeSection, handleActive }) => {
  const { mainEventFormFilledPercentage } = useEvent();

  return (
    <div className="sidebar">
      <div
        className={`section ${activeSection === "main-event" ? "active" : ""}`}
        onClick={() => handleActive("main-event")}
      >
        <MdEvent className="icon" />
        <Link to="main-event">
          Main Event
          <span
            style={{
              color: "#00FF00",
              fontWeight: "bold",
            }}
          >
            {mainEventFormFilledPercentage} %{" "}
          </span>
        </Link>
      </div>
      <div
        className={`section ${activeSection === "location" ? "active" : ""}`}
        onClick={() => handleActive("location")}
      >
        <MdLocationOn className="icon" />
        <Link to="location">Location Details</Link>
      </div>
      <div
        className={`section ${activeSection === "speakers" ? "active" : ""}`}
        onClick={() => handleActive("speakers")}
      >
        <FaMicrophone className="icon" />
        <Link to="speakers">List of Speakers</Link>
      </div>
      <div
        className={`section ${
          activeSection === "registration" ? "active" : ""
        }`}
        onClick={() => handleActive("registration")}
      >
        <FaUserPlus className="icon" />
        <Link to="speakers">Registration</Link>
      </div>
      <div
        className={`section ${activeSection === "sponsor" ? "active" : ""}`}
        onClick={() => handleActive("sponsor")}
      >
        <FaHandshake className="icon" />
        <Link to="sponsor">List of Sponser</Link>
      </div>
      <div
        className={`section ${activeSection === "stalls" ? "active" : ""}`}
        onClick={() => handleActive("stalls")}
      >
        <FaStore className="icon" />
        <Link to="stalls">List of Stalls</Link>
      </div>
      <div
        className={`section ${activeSection === "subEvent" ? "active" : ""}`}
        onClick={() => handleActive("subEvent")}
      >
        <FaCalendarAlt className="icon" />
        <Link to="subEvent">Sub Event</Link>
      </div>
      <div
        className={`section ${activeSection === "agenda" ? "active" : ""}`}
        onClick={() => handleActive("agenda")}
      >
        <MdEventNote className="icon" />
        <Link to="agenda">Agenda</Link>
      </div>
    </div>
  );
};

export default SideBar;
